import {
    FETCH_BLOCKED_USER_LIST_START,
    FETCH_BLOCKED_USER_LIST_SUCCESS,
    FETCH_BLOCKED_USER_LIST_FAIL,
    UNBLOCK_USER_START,
    UNBLOCK_USER_SUCCESS,
    UNBLOCK_USER_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    blockedUserList: [],
    blockedUserListFetching: false,
    blockedUserListFetchSuccess: false,
    blockedUserListFetchFail: false,
    userUnblocking: false,
    userUnblockSuccess: false,
    userUnblockFail: false
};

const blockedUserListFetching = (state) => ({
    ...state,
    blockedUserListFetching: true,
    blockedUserListFetchSuccess: false,
    blockedUserListFetchFail: false
});

const fetchBlockedUserListFinished = (isSuccess) => (state, { blockedUserList }) => ({
    ...state,
    blockedUserList,
    blockedUserListFetching: false,
    blockedUserListFetchSuccess: isSuccess,
    blockedUserListFetchFail: !isSuccess
});

const userUnblocking = (state) => ({
    ...state,
    userUnblocking: true,
    userUnblockSuccess: false,
    userUnblockFail: false
});

const userUnblockFinished = (isSuccess) => (state) => ({
    ...state,
    userUnblocking: false,
    userUnblockSuccess: isSuccess,
    userUnblockFail: !isSuccess
});

const handlers = {
    [FETCH_BLOCKED_USER_LIST_START]: blockedUserListFetching,
    [FETCH_BLOCKED_USER_LIST_SUCCESS]: fetchBlockedUserListFinished(true),
    [FETCH_BLOCKED_USER_LIST_FAIL]: fetchBlockedUserListFinished(false),
    [UNBLOCK_USER_START]: userUnblocking,
    [UNBLOCK_USER_SUCCESS]: userUnblockFinished(true),
    [UNBLOCK_USER_FAIL]: userUnblockFinished(false)
};

export const getBlockedUserListFetching = (state) => state.blockUser.blockedUserListFetching;
export const getBlockedUserListFetchFail = (state) => state.blockUser.blockedUserListFetchFail;
export const getBlockedUserList = (state) => state.blockUser.blockedUserList;
export const getUserUnblocking = (state) => state.blockUser.userUnblocking;
export const getUserUnblockSuccess = (state) => state.blockUser.userUnblockSuccess;
export const getUserUnblockFail = (state) => state.blockUser.userUnblockFail;

export default function blockUser(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
